import { render, staticRenderFns } from "./VSvgIcon.vue?vue&type=template&id=41d8e0cd"
import script from "./VSvgIcon.vue?vue&type=script&lang=js"
export * from "./VSvgIcon.vue?vue&type=script&lang=js"
import style0 from "./VSvgIcon.vue?vue&type=style&index=0&id=41d8e0cd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports